import React, { useCallback } from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import Comment from './../comment/Comment';
import PortfolioLinks from './../portfolioLinks/PortfolioLinks';
import UploadFiles from './../uploadFiles/UploadFiles';
import PropTypes from 'prop-types';

const popupSteps = {
    brief: 'brief',
    portfolio: 'portfolio',
};

const validationSchema = yup.object().shape({
    comment: yup.string(),
    portfolioLinks: yup.array().of(
        yup.object({
            link: yup
                .string()
                .matches(
                    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
                    'Enter correct url!'
                ),
            // .required('Please enter link'),
        })
    ),
    files: yup.array(),
});

const PortfolioForm = ({
    postId,
    handleSubmit,
    handleResponseForInviteWithoutPortfolio,
    portfolioInitialState,
    currentScreen,
    setCurrentScreen,
    briefLink,
    onlyReadable,
    handleDecline,
}) => {
    const handleNextStep = useCallback(
        e => {
            e.stopPropagation();
            e.preventDefault();
            setCurrentScreen(popupSteps.portfolio);
        },
        [setCurrentScreen]
    );

    const handleStopPropagation = useCallback(e => e.stopPropagation(), []);

    return (
        <Formik
            initialValues={portfolioInitialState}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ values, setValues, isSubmitting, errors, touched, handleChange }) => {
                return (
                    <Form className="form-wrap" onClick={handleStopPropagation}>
                        <div className="add-portfolio-subheader">
                            {currentScreen === popupSteps.brief ? (
                                'Preview the full brief for this project.'
                            ) : (
                                <>
                                    <b>You don&apos;t have to do this right now.</b> A deadline
                                    might be outlined in the brief so make sure that you read the
                                    brief carefully. You will be notified if you&apos;re successful
                                    or not so watch this space!
                                </>
                            )}
                        </div>
                        {currentScreen === popupSteps.brief ? (
                            <iframe
                                src={briefLink}
                                // src={`https://docs.google.com/document/d/1qq07GXN98iw8PEE1gZq0bVwKDXsb-rkaej8J0eEU-ZI/edit?usp=sharing`}
                                style={{ width: '100%', flexGrow: 1 }}
                            />
                        ) : (
                            <>
                                <div className="modal-field">
                                    <UploadFiles
                                        values={values}
                                        setValues={setValues}
                                        errors={errors}
                                        touched={touched}
                                        name="files"
                                        postId={postId}
                                    />
                                </div>
                                <div className="modal-field">
                                    <PortfolioLinks
                                        name="portfolioLinks"
                                        values={values}
                                        setValues={setValues}
                                        errors={errors}
                                        touched={touched}
                                    />
                                </div>
                                <div className="modal-field">
                                    <Comment
                                        name="comment"
                                        values={values}
                                        touched={touched}
                                        errors={errors}
                                        maxLength={250}
                                        placeholder="Enter text"
                                        handleChange={handleChange}
                                    />
                                </div>
                            </>
                        )}
                        {!onlyReadable && (
                            <div className="portfolio-modal-footer">
                                {currentScreen === popupSteps.brief ? (
                                    <>
                                        <button
                                            disabled={isSubmitting}
                                            type="button"
                                            onClick={handleDecline}
                                            className="add-portfolio-submit-btn with-portfolio"
                                        >
                                            Not interested
                                        </button>
                                        <button
                                            disabled={isSubmitting}
                                            type="button"
                                            className="add-portfolio-submit-btn"
                                            onClick={handleNextStep}
                                        >
                                            Still interested
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button
                                            disabled={isSubmitting}
                                            type="button"
                                            className="add-portfolio-submit-btn"
                                            onClick={handleResponseForInviteWithoutPortfolio}
                                        >
                                            Submit later
                                        </button>
                                        <button
                                            disabled={isSubmitting}
                                            type="submit"
                                            className="add-portfolio-submit-btn with-portfolio"
                                        >
                                            Submit now
                                        </button>
                                    </>
                                )}
                            </div>
                        )}
                    </Form>
                );
            }}
        </Formik>
    );
};

PortfolioForm.propTypes = {
    postId: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleResponseForInviteWithoutPortfolio: PropTypes.func.isRequired,
    portfolioInitialState: PropTypes.any.isRequired,
    currentScreen: PropTypes.string.isRequired,
    setCurrentScreen: PropTypes.func.isRequired,
    briefLink: PropTypes.any,
    onlyReadable: PropTypes.bool.isRequired,
    handleDecline: PropTypes.func.isRequired,
};

export default PortfolioForm;
